import { useIntl, useSettings } from '@capsicum/common';

export const useExportAndCloseAccountIntro = () => {
	const { $t } = useIntl();
	const { settings } = useSettings();

	return {
		intlTexts: {
			cancelButton: $t('global.button.cancel'),
			exportAndCloseAccountButton: $t('settings.accountManagement.exportAndCloseAccount'),
			subtitle: $t('settings.accountManagement.pleaseProceedWithCaution'),
			title: $t('settings.accountManagement.deletingYourAccountIsIrreversible')
		},
		privacyLink: settings.privacyPolicyLink,
		supportLink: settings.contactUsHereLink
	};
};
